import { URI } from '@fiverr-private/futile';

export const enrichURI = (uri: string, params: Record<string, string>): string => new URI(uri).addParams(params).href;
